/* eslint-disable */
/**
 * The stylesheet used by the PDF export template.
 *
 * GENERATED - a copy of the style block in medusa/ce-app-api/server/templates/pdf-layout.html,
 * which is the source of truth. Do not edit this file: change the template, then re-copy its style
 * block here.
 */
export const PDF_LAYOUT_CSS = String.raw`
.pages-in-this-section h3 {
    color: #212D38 !important;
    font-weight: 700 !important;
    font-family: Gilroy, Roboto, "Helvetica Neue", sans-serif !important;
}

.pages-in-this-section a {
    color: #467785 !important;
    /* Style-04 */
    font-weight: 700 !important;
    font-family: Gilroy, Roboto, "Helvetica Neue", sans-serif !important;
    line-height: 25px !important;
}

.readable-content {
    /* HTML5 display-role reset for older browsers */
    font-family: Roboto, "Helvetica Neue", sans-serif;
    font-size: 1em;
    color: #555;
    position: relative;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased !important;
    -moz-font-smoothing: antialiased !important;
    text-rendering: optimizelegibility !important;
    line-height: 1.58;
    letter-spacing: .003em;
}

.readable-content html, .readable-content body, .readable-content div, .readable-content span, .readable-content applet, .readable-content object, .readable-content iframe,
.readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6, .readable-content p, .readable-content blockquote, .readable-content pre,
.readable-content a, .readable-content abbr, .readable-content acronym, .readable-content address, .readable-content big, .readable-content cite, .readable-content code,
.readable-content del, .readable-content dfn, .readable-content em, .readable-content img, .readable-content ins, .readable-content kbd, .readable-content q, .readable-content s, .readable-content samp,
.readable-content small, .readable-content strike, .readable-content strong, .readable-content sub, .readable-content sup, .readable-content tt, .readable-content var,
.readable-content b, .readable-content u, .readable-content i, .readable-content center,
.readable-content dl, .readable-content dt, .readable-content dd, .readable-content ol, .readable-content ul, .readable-content li,
.readable-content fieldset, .readable-content form, .readable-content label, .readable-content legend,
.readable-content table, .readable-content caption, .readable-content tbody, .readable-content tfoot, .readable-content thead, .readable-content tr, .readable-content th, .readable-content td,
.readable-content article, .readable-content aside, .readable-content canvas, .readable-content details, .readable-content embed,
.readable-content figure, .readable-content figcaption, .readable-content footer, .readable-content header, .readable-content hgroup,
.readable-content main, .readable-content menu, .readable-content nav, .readable-content output, .readable-content ruby, .readable-content section, .readable-content summary,
.readable-content time, .readable-content mark, .readable-content audio, .readable-content video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
}

.readable-content article, .readable-content aside, .readable-content details, .readable-content figcaption, .readable-content figure,
.readable-content footer, .readable-content header, .readable-content hgroup, .readable-content main, .readable-content menu, .readable-content nav, .readable-content section {
    display: block; 
}

.readable-content body {
    line-height: 1; 
}

.readable-content ol, .readable-content ul {
    list-style: none; 
}

ul.toc-list {
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
}

ul.toc-list > li {
  padding-left: 0 !important;
}

ul.toc-list > li:before { 
    content: "\27A2";
    padding-right: 8px;
    color: #bdc0c0 !important;
}

.readable-content blockquote, .readable-content q {
    quotes: none; 
}

.readable-content blockquote:before, .readable-content blockquote:after, .readable-content q:before, .readable-content q:after {
    content: '';
    content: none;
}

.readable-content .page-title, .readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6 {
    margin: 1.3rem 0;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    font-weight: 700;
    color: #222; 
}

.readable-content .module-name {
    font-weight: 400;
    font-size: 28px;    
    line-height: 125%;
    text-align: center;
    color: #222;
    font-family: Roboto, "Helvetica Neue", sans-serif;
}

.readable-content h1 {
    font-weight: 700;
    font-size: 22px;
    line-height: 125%;
}
.readable-content h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 125%;
}
.readable-content h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 125%;
}
.readable-content h4 {
    font-weight: 700;
    font-size: 16px;
    line-height: 125%;
}
.readable-content h5,
.readable-content h6 {
    font-weight: 700;
    font-size: 14px;
    line-height: 125%;
}

.readable-content a {
    color: #555;
    text-decoration: underline;
}

.readable-content a:hover {
    color: #222;
}

.readable-content mark {
    color: #555;
    background-color: rgba(82, 232, 165, 0.3);
}

.readable-content strong, .readable-content b {
    font-weight: 700;
}

.readable-content em, .readable-content i, .readable-content cite, .readable-content blockquote, .readable-content q {
    font-style: italic;
}

.readable-content small {
    font-size: 0.78em;
}

.readable-content big {
    font-size: 1.56em;
}

.readable-content abbr[title], .readable-content acronym[title] {
    text-decoration: underline dotted;
}

.readable-content sup {
    vertical-align: super;
    font-size: 0.78em;
}

.readable-content sub {
    vertical-align: sub;
    font-size: 0.78em;
}

.readable-content u {
    text-decoration: underline;
}

.readable-content img {
    max-width: 100%;
    display: block;
    margin: 1.3em auto;
}

.readable-content img.big {
    margin: 1em 0;
    width: 120%;
    margin-left: -10%;
}

/*
 * Image layout modes authored via the TipTap image bubble menu (data-layout).
 * Values mirror the :deep(img[data-layout='...']) block in policy-connect
 * CEModuleRenderer.vue so PDF, editor and published views agree.
 * Cite the file and that selector block, never a line number: this points
 * across a submodule boundary, where line anchors rot silently.
 * Value-specific selectors only: an <img> with no data-layout attribute
 * (pre-feature content never re-saved) must keep the centered
 * '.readable-content img' behaviour above — do not add a bare
 * img[data-layout] catch-all.
 */
.readable-content img[data-layout="inline"] {
    display: inline-block;
    margin: 0 0.25rem;
    vertical-align: middle;
}

.readable-content img[data-layout="left-wrap"] {
    display: block;
    float: left;
    margin: 0.25rem 1rem 0.5rem 0;
}

.readable-content img[data-layout="right-wrap"] {
    display: block;
    float: right;
    margin: 0.25rem 0 0.5rem 1rem;
}

.readable-content img[data-layout="left"] {
    display: block;
    float: none;
    margin: 0.5rem auto 0.5rem 0;
}

.readable-content img[data-layout="center"] {
    display: block;
    float: none;
    margin: 0.5rem auto;
}

.readable-content img[data-layout="right"] {
    display: block;
    float: none;
    margin: 0.5rem 0 0.5rem auto;
}

.readable-content p {
    margin: 1em 0;
    line-height: 1.58;
    color: #555;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    overflow-wrap: anywhere;
}

.readable-content blockquote {
    margin: 1em 0 1em 1em;
    border-left: 0.325em solid #dddddd;
    padding-left: 1em;
}

.readable-content code {
    background-color: #dddddd;
    opacity: .9;
    padding: 0.1625em 0.325em;
    border-radius: 3px;
}

.readable-content ul {
    list-style: disc outside none;
    margin-left: 1.5rem;
}

.readable-content ol {
    list-style: decimal outside none;
}

.readable-content li {
    margin-right: 0;
    margin-left: 1em;
}

.readable-content dl {
    margin: 1em 0;
}

.readable-content dl dt {
    font-weight: 700;
}

.readable-content dl dd {
    margin-left: 1em;
}

.readable-content dl dt + dd {
    margin-bottom: 1em;
}

.readable-content table {
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0; 
    vertical-align: middle;
    width: 100%;
    table-layout: fixed;
}

.readable-content table[style] {
    max-width: 100% !important;
    min-width: 0 !important;
}

.readable-content td, .readable-content th {
    vertical-align: middle;
    border-width: 1px;
    border-style: solid;
    border-color: #777;
    padding: 8px;
    word-wrap: break-word !important;
}

.readable-content thead th, .readable-content tbody th {
    background-color: #f2f2f2;
    font-weight: 700;
}

.readable-content .page-title {
    font-size: 28px;
    font-weight: 400;
    color: #555757;
    line-height: 32px;
    letter-spacing: normal;
}

.readable-content .display-name {
    font-size: 22px;
    font-weight: 400;
    color: #555757;
    line-height: 32px;
    letter-spacing: normal;
}

button {
    display: none;
}

.readable-content .divHeader, .readable-content .divFooter {
    width: 100%;
    color: LightGray;
    display: block;
    font-size: 0.90rem;
    margin-bottom: 1em;
}

.readable-content .logo-top {
    max-width: 250px !important;
    max-height: 250px !important;
    display: block;
}

.readable-content .placeholder {
    background: #FFE066;
}

.readable-content .validContext {
    background: #5D6977;
    color: #ffffff;
    font-weight: bold;
}

.readable-content .display-name {
    font-size: 22px;
    font-weight: 400;
    color: #555757;
    letter-spacing: normal;
    margin: 0;
    text-align: center;
}

@media print {
    body {
        -webkit-print-color-adjust: exact;
        color-adjust: exact; 
    }

    .readable-content li p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    table {
        page-break-inside: auto;
    }

    thead, tfoot {
        page-break-inside: auto;
        background-color: white;
        width: 100%;
    }

    tbody {
        page-break-inside: auto;
    }

    tr { 
        page-break-inside: auto; 
        page-break-after: auto;
    }

    img {
        page-break-before: auto; 
        page-break-after: auto; 
        page-break-inside: avoid;
        display: block;
        margin: 0 auto 1rem auto;
        max-width: 80% !important;
    }

    .readable-content img {
        max-width: 100%;
        max-height: 500px;
        display: block;
        margin: 1.3em auto;
    }

    /*
     * why: the export calls emulateMediaType('print') (in
     * lib/ce-app-api/handlers/modules.js and
     * lib/ce-sdk/content-engine/components/ce-modules/index.js), so the base
     * style block's rules above alone would not apply here.
     */
    .readable-content img[data-layout="inline"] {
        display: inline-block;
        margin: 0 0.25rem;
        vertical-align: middle;
    }

    .readable-content img[data-layout="left-wrap"] {
        display: block;
        float: left;
        margin: 0.25rem 1rem 0.5rem 0;
    }

    .readable-content img[data-layout="right-wrap"] {
        display: block;
        float: right;
        margin: 0.25rem 0 0.5rem 1rem;
    }

    .readable-content img[data-layout="left"] {
        display: block;
        float: none;
        margin: 0.5rem auto 0.5rem 0;
    }

    .readable-content img[data-layout="center"] {
        display: block;
        float: none;
        margin: 0.5rem auto;
    }

    .readable-content img[data-layout="right"] {
        display: block;
        float: none;
        margin: 0.5rem 0 0.5rem auto;
    }

    .readable-content td, .readable-content .page-title {
        padding-top: 0; 
        margin-top: 0;
    }
}
`;

export default PDF_LAYOUT_CSS;
